import { Link } from 'react-router-dom';

import FFLogo from '@/assets/images/ff-logo.png';
import { getFallbackURL } from '@/lib/route';

const Logo = ({
  width = 150,
  height = 40,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <Link to={getFallbackURL()}>
      <img
        src={FFLogo}
        alt="Franchise Frameworks Logo"
        width={width}
        height={height}
      />
    </Link>
  );
};

export { Logo };
